export const selectIsAuthLoading = (state) => state.auth.isLoading;

export const selectSitePasswordValidated = (state) => true;//state.auth.sitePasswordValidated;

export const selectToken = (state) => state.auth.token;

export const selectSessionId = (state) => state.auth.sessionId;